module.exports = __webpack_public_path__ + "static/media/profile-pic (1).0cf59c0a.png";